import { useEffect, useState } from 'react'
import { useHistory } from 'react-router-dom'
import { IconPlusCircleWhite, IconRegistrationEmptyVehicle } from '../../assets/icons'
import networkErrorImage from '../../assets/images/quanlydangki_loimang.png'
import BaseButton from '../../components/BasicComponent/BaseButton'
import BottomBar from '../../components/BasicComponent/BottomBar'
import HomeBannerCache from '../../components/BasicComponent/HomeBannerCache'
import LoadingScreen from '../../components/BasicComponent/LoadingScreen'
import SafeImage from '../../components/BasicComponent/SafeImage'
import VehicleItem from '../../components/BasicComponent/VehicleItem'
import VehicleItemSkeletonList from '../../components/BasicComponent/VehicleItemSkeletonList'
import { PATH } from '../../constants/router'
import { useAppUserContext } from '../../context/AppUserContext'
import { useTrafficFineVehicleContext } from '../../context/TrafficFineVehicleContext'
import useLoadHomeCache from '../../hooks/common/useLoadHomeCache'
import useRefreshTrafficFineVehicleListOnRouteEnter from '../../hooks/common/useRefreshTrafficFineVehicleListOnRouteEnter'
import LayoutPartner from '../../components/BasicComponent/LayoutPartner'
import { useAppParamsContext } from '../../context/AppParamsContext'
import { getThemeFeatureConfig } from '../../constants/appThemeNameConfig'
import './index.scss'

export default function TrafficFineRegistrationManagement() {
  const history = useHistory()
  const { isHeaderMiniApp, appThemeName } =
    useAppParamsContext()

  const config = getThemeFeatureConfig(appThemeName, 'TRAFFIC_FINE_REGISTRATION_MANAGEMENT')

  const { homeBanners, homeCacheLoading } = useLoadHomeCache()
  const { userData } = useAppUserContext()
  const { listVehicleRegisteredPackage, isLoadingVehicleList, isVehicleListNetworkError, getVehicleLists } = useTrafficFineVehicleContext()
  const registeredVehicles = listVehicleRegisteredPackage
  const hasRegisteredVehicles = registeredVehicles.length > 0
  const [shouldShowEmptyState, setShouldShowEmptyState] = useState(false)

  useRefreshTrafficFineVehicleListOnRouteEnter({
    isLoading: isLoadingVehicleList,
    refreshVehicleList: getVehicleLists
  })

  useEffect(() => {
    if (hasRegisteredVehicles || isLoadingVehicleList || isVehicleListNetworkError) {
      setShouldShowEmptyState(false)
      return
    }

    const timeoutId = window.setTimeout(() => {
      setShouldShowEmptyState(true)
    }, 0)

    return () => {
      window.clearTimeout(timeoutId)
    }
  }, [hasRegisteredVehicles, isLoadingVehicleList, isVehicleListNetworkError])

  const openServicesPage = () => {
    history.push({
      pathname: PATH.TRAFFIC_FINE_SERVICES,
      state: {
        phoneNumber: userData?.phoneNumberWithUsernamePrefix
      }
    })
  }

  const goToPackageInfo = (vehicle) => {
    history.push({
      pathname: PATH.TRAFFIC_FINE_PACKAGE_INFO,
      state: {
        vehicleIdentity: vehicle?.vehicleIdentity,
        vehicleType: vehicle?.vehicleType,
        vehicleActivePackage: vehicle
      }
    })
  }

  const handleRetryLoadVehicles = () => {
    void getVehicleLists()
  }

  const showNetworkError = isVehicleListNetworkError && !isLoadingVehicleList && !hasRegisteredVehicles

  const showRegisterBottomButton = config.showBottomRegisterButtonAlways ? (hasRegisteredVehicles || shouldShowEmptyState) : shouldShowEmptyState

  const bottomBarTopContent = showNetworkError ? (
    <div className="TrafficFineRegistrationManagement_bottomAction">
      <BaseButton onClick={handleRetryLoadVehicles}>Thử lại</BaseButton>
    </div>
  ) : showRegisterBottomButton ? (
    <div className="TrafficFineRegistrationManagement_bottomAction">
      <BaseButton
        className={
          config.headerStyleVersion === 2
            ? 'TrafficFineRegistrationManagement_registerButtonBidv'
            : ''
        }
        onClick={openServicesPage}
      >
        {config.showBottomRegisterButtonIcon ? (
          <IconPlusCircleWhite className="TrafficFineRegistrationManagement_registerButtonIcon" />
        ) : null}

        <span>Đăng ký ngay</span>
      </BaseButton>
    </div>
  ) : null

  return (
    <LayoutPartner noHeader={!isHeaderMiniApp} headerTitle="Quản lý đăng ký">

      <div className="TrafficFineRegistrationManagement">
        {isLoadingVehicleList ? (
          <div className="TrafficFineRegistrationManagement_list">
            <VehicleItemSkeletonList itemKeyPrefix="traffic-fine-registration-management-skeleton" />
          </div>
        ) : showNetworkError ? (
          <div className="TrafficFineRegistrationManagement_empty">
            <SafeImage src={networkErrorImage} className="TrafficFineRegistrationManagement_emptyImage" />

            <div className="TrafficFineRegistrationManagement_emptyTitle">Không thể tải danh sách xe</div>
            <div className="TrafficFineRegistrationManagement_emptyDescription">Vui lòng kiểm tra kết nối mạng và thử lại</div>
          </div>
        ) : hasRegisteredVehicles ? (
          <>
            <div className="TrafficFineRegistrationManagement_header">
              <div className="TrafficFineRegistrationManagement_headerContent">
                <div className={`TrafficFineRegistrationManagement_headerTitle ${config.headerStyleVersion === 2 ? 'TrafficFineRegistrationManagement_headerTitle--bidv' : ''}`}>
                  Xe đã đăng ký ({registeredVehicles.length})
                </div>
                <div className="TrafficFineRegistrationManagement_headerDescription">
                  {config.headerDescriptionText}
                </div>
              </div>

              {config.showHeaderAddButton && (
                <button type="button" className="TrafficFineRegistrationManagement_addButton" onClick={openServicesPage}>
                  <span>Thêm xe</span>
                  <IconPlusCircleWhite className="TrafficFineRegistrationManagement_addButtonIcon" />
                </button>
              )}
            </div>

            <div className="TrafficFineRegistrationManagement_list">
              {registeredVehicles.map((vehicle, index) => (
                <VehicleItem
                  key={vehicle?.appUserVehicleNotifyInfoId || `${vehicle?.vehicleIdentity}-${vehicle?.vehicleType}-${index}`}
                  vehicleIdentity={vehicle?.vehicleIdentity}
                  vehicleType={vehicle?.vehicleType}
                  isRegisteredPackage
                  registeredPackageMode={2}
                  notifyEndDateTime={vehicle?.notifyEndDateTime}
                  allowRenew={vehicle?.allowRenew}
                  onClick={() => {}}
                  onClickArrowRight={() => goToPackageInfo(vehicle)}
                  onActionClick={() => goToPackageInfo(vehicle)}
                />
              ))}
            </div>

            {config.showHomeBanner && (
              <HomeBannerCache promoBanners={homeBanners} loading={homeCacheLoading} />
            )}
          </>
        ) : shouldShowEmptyState ? (
          <div className="TrafficFineRegistrationManagement_empty">
            <IconRegistrationEmptyVehicle className="TrafficFineRegistrationManagement_emptyImage" />

            <div className="TrafficFineRegistrationManagement_emptyTitle">
              {config.emptyStateTitle}
            </div>

            {config.showEmptyStateDescription ? (
              <div className="TrafficFineRegistrationManagement_emptyDescription">
                Vui lòng thêm xe để theo dõi tự động và nhận thông báo vi phạm
                kịp thời qua tin nhắn SMS
              </div>
            ) : null}
          </div>
        ) : null}
      </div>

      <BottomBar elementPaddingBottom="LayoutPartner" tabActive={2} topContent={bottomBarTopContent} onLookupClick={() => history.goBack()} />
      <LoadingScreen open={isLoadingVehicleList} />
    </LayoutPartner>
  )
}
